import React from 'react'
import type { AcompanhamentoFilterConfig } from 'view/acompanhamento/model/model-acompanhamentoFilter'

import { AcompanhamentoFilterItem } from './AcompanhamentoFilterItem'

type AcompanhamentoFilterListProps<T> = {
  filtro: T
  config: Readonly<AcompanhamentoFilterConfig<T>[]>
}

export function AcompanhamentoFilterList<T>({ filtro, config }: Readonly<AcompanhamentoFilterListProps<T>>) {
  return (
    <>
      {config.map((c: AcompanhamentoFilterConfig<T>) => {
        if (c.shouldRender && !c.shouldRender(filtro)) return null
        const value = c.getValue?.(filtro)
        if (!value) return null
        return <AcompanhamentoFilterItem key={c.label} label={c.label} value={value} />
      })}
    </>
  )
}
